export const handleSort = (sortColumns, columnName, setState = () => {}) => {
  if (!sortColumns) return;
  const existingSort = sortColumns.find((x) => x.name === columnName);

  if (existingSort) {
    const updatedSort = {
      name: existingSort.name,
      label: existingSort.label,
      sortDirection: existingSort.sortDirection === 0 ? 1 : 0,
    };
    setState({
      sortColumns: sortColumns.map((x) =>
        x.name === columnName ? updatedSort : x,
      ),
      updatedSortColumn: updatedSort,
    });
  }
};

export const handleCustomerSort = (
  sortColumns,
  columnName,
  setState = () => {},
) => {
  if (!sortColumns) return;
  const existingSort = sortColumns.find((x) => x.name === columnName);

  if (existingSort) {
    const updatedSort = {
      name: existingSort.name,
      sortDirection: existingSort.sortDirection === 0 ? 1 : 0,
    };
    setState({
      sortableColumns: sortColumns.map((x) =>
        x.name === columnName ? updatedSort : x,
      ),
      updatedSortColumn: updatedSort,
    });
  }
};

export const getSortDirection = (sortColumns, columnName) => {
  if (!sortColumns) return;
  const sortColumn = sortColumns.find((x) => x.name === columnName);
  if (!sortColumn) return null;
  return sortColumn.sortDirection === 0 ? "ascending" : "descending";
};
